import type { Dict } from "./types";

export const bn: Dict = {
  common: {
    save: "পরিবর্তন সেভ করুন",
    saving: "সেভ হচ্ছে…",
    cancel: "বাতিল করুন",
    remove: "সরান",
    continue: "এগিয়ে যান",
    somethingWrong: "কিছু একটা সমস্যা হয়েছে",
    logOut: "লগ আউট",
    welcomeBackGreet: "আবার স্বাগতম,",
    hiGreet: "হাই,",
    statusOpen: "খোলা",
    statusInProgress: "চলছে",
    statusResolved: "সমাধান হয়েছে",
  },
  requests: {
    categoryLabel: "বিভাগ (ঐচ্ছিক)",
    categoryPlumbing: "প্লাম্বিং",
    categoryElectrical: "ইলেকট্রিক্যাল",
    categoryAppliance: "যন্ত্রপাতি",
    categoryFurniture: "আসবাবপত্র",
    categoryCleaning: "পরিষ্কার-পরিচ্ছন্নতা",
    categoryPestControl: "পেস্ট কন্ট্রোল",
    categoryOther: "অন্যান্য",
    urgentCheckboxLabel: "এটি জরুরি",
    urgentBadge: "জরুরি",
    photoLabel: "ছবি যোগ করুন (ঐচ্ছিক)",
    addPhotoBtn: "ছবি যোগ করুন",
    removePhotoAria: "ছবি সরান",
    updatesHeading: "আপডেট",
    noUpdatesYet: "এখনো কোনো আপডেট নেই।",
    addCommentPlaceholder: "একটি নোট যোগ করুন…",
    postCommentBtn: "পোস্ট করুন",
    postingCommentBtn: "পোস্ট হচ্ছে…",
    callBtn: "কল করুন",
    whatsappBtn: "হোয়াটসঅ্যাপ",
  },
  nav: {
    home: "হোম",
    listings: "লিস্টিং",
    notebook: "নোটবুক",
    requests: "রিকোয়েস্ট",
    settings: "সেটিংস",
    browse: "প্রপার্টি দেখুন",
    payments: "পেমেন্ট",
    ownerDashboard: "মালিক ড্যাশবোর্ড",
    tenantDashboard: "ভাড়াটে ড্যাশবোর্ড",
  },
  auth: {
    welcomeEyebrow: "স্বাগতম",
    welcomeTitle: "ToLetBook-এ স্বাগতম",
    welcomeSub: "আপনার অ্যাকাউন্টে লগ ইন করুন, অথবা নতুন একটি তৈরি করুন।",
    logIn: "লগ ইন করুন",
    createAccount: "অ্যাকাউন্ট তৈরি করুন",
    loginTitle: "আবার স্বাগতম",
    loginSub: "আপনার ড্যাশবোর্ডে যেতে লগ ইন করুন।",
    registerTitle: "আপনার অ্যাকাউন্ট তৈরি করুন",
    registerSub: "একটি সম্পত্তি তালিকাভুক্ত করুন বা আপনার পরবর্তী বাড়ি খুঁজুন — কোনো ব্রোকার ছাড়াই, কোনো ঝামেলা ছাড়াই।",
    passwordHint: "কমপক্ষে ৬টি অক্ষর।",
    referralCodeLabel: "রেফারেল কোড (ঐচ্ছিক)",
    referralCodePlaceholder: "আপনার কাছে কোড থাকলে লিখুন",
    agreeTermsText: "আমি ToLetBook-এর নিয়ম ও শর্তাবলী এবং গোপনীয়তা নীতিতে সম্মত",
    viewTermsLink: "নিয়ম ও শর্তাবলী দেখুন",
    viewPrivacyLink: "গোপনীয়তা নীতি দেখুন",
    hideTermsLink: "নিয়ম ও শর্তাবলী লুকান",
    errMustAgreeTerms: "চালিয়ে যেতে অনুগ্রহ করে নিয়ম ও শর্তাবলীতে সম্মত হন",
    loginBusy: "লগ ইন হচ্ছে…",
    emailLabel: "ইমেইল",
    emailPlaceholder: "you@example.com",
    passwordLabel: "পাসওয়ার্ড",
    passwordPlaceholder: "আপনার পাসওয়ার্ড",
    errEmailPassword: "আপনার ইমেইল ও পাসওয়ার্ড লিখুন",
    getStartedEyebrow: "শুরু করুন",
    roleTitle: "আপনি কে বলুন",
    roleSub: "যাতে আমরা আপনার জন্য সঠিক ড্যাশবোর্ড তৈরি করতে পারি।",
    roleOwnerTitle: "আমি একজন প্রপার্টি / পিজি মালিক",
    roleOwnerSub: "প্রপার্টি লিস্ট করুন, ভাড়াটে ম্যানেজ করুন, ভাড়া ট্র্যাক করুন",
    roleTenantTitle: "আমি একজন ভাড়াটে",
    roleTenantSub: "লিস্টিং দেখুন, ভাড়া দিন, রিকোয়েস্ট পাঠান",
    step1Eyebrow: "ধাপ 1",
    credentialsTitle: "আপনার লগইন তৈরি করুন",
    newPasswordPlaceholder: "কমপক্ষে 6 অক্ষর",
    phoneOptionalLabel: "মোবাইল নম্বর (ঐচ্ছিক)",
    phonePlaceholder: "10 সংখ্যার মোবাইল নম্বর",
    errValidEmail: "একটি সঠিক ইমেইল ঠিকানা লিখুন",
    errPasswordLength: "পাসওয়ার্ড কমপক্ষে 6 অক্ষরের হতে হবে",
    errValidPhoneOptional: "10 সংখ্যার সঠিক মোবাইল নম্বর লিখুন, অথবা খালি রাখুন",
    step2Eyebrow: "ধাপ 2",
    profileTitle: "আপনার সম্পর্কে একটু বলুন",
    fullNameLabel: "পুরো নাম",
    fullNamePlaceholder: "আপনার পুরো নাম",
    profileBusy: "একটু অপেক্ষা করুন…",
    errName: "আপনার নাম লিখুন",
    step3Eyebrow: "ধাপ 3",
    propertyTypeTitle: "আপনি কী ম্যানেজ করেন?",
    propertyTypeSub: "এটা ঠিক করবে আপনি কোন ড্যাশবোর্ড দেখবেন — পরে এটা বদলাতে পারবেন।",
    typeIndependentTitle: "ইন্ডিপেন্ডেন্ট প্রপার্টি",
    typeIndependentSub: "পুরো বাড়ি, ফ্ল্যাট, ভিলা",
    typePgTitle: "পিজি / হোস্টেল",
    typePgSub: "বেড অনুযায়ী ভাড়া নেওয়া শেয়ার্ড রুম",
    typeBothTitle: "দুটোই",
    typeBothSub: "ইন্ডিপেন্ডেন্ট ইউনিট ও পিজি রুমের মিশ্রণ",
    almostDoneEyebrow: "প্রায় শেষ",
    cityTitle: "আপনি কোথায় কাজ করেন?",
    citySub: "এর মাধ্যমে আমরা আপনার লিস্টিং কাছাকাছি ভাড়াটেদের আগে দেখাব।",
    cityLabel: "শহর",
    cityPlaceholder: "যেমন মুম্বাই",
    bankDetailsTitle: "আমরা আপনাকে কীভাবে পেমেন্ট করব?",
    bankDetailsSub: "ভাড়া এবং ডিপোজিট পেমেন্ট সরাসরি আপনাকে পাঠানোর জন্য আপনার ব্যাংক অ্যাকাউন্ট যোগ করুন।",
    payoutMethodUpi: "UPI আইডি",
    payoutMethodBank: "ব্যাংক অ্যাকাউন্ট",
    upiIdLabel: "UPI আইডি",
    upiIdPlaceholder: "যেমন name@okhdfcbank",
    errValidUpi: "সঠিক UPI আইডি লিখুন",
    bankAccountHolderLabel: "অ্যাকাউন্ট হোল্ডারের নাম",
    bankAccountHolderPlaceholder: "ব্যাংক রেকর্ড অনুযায়ী",
    bankAccountNumberLabel: "অ্যাকাউন্ট নম্বর",
    bankAccountNumberPlaceholder: "ব্যাংক অ্যাকাউন্ট নম্বর",
    bankIfscLabel: "IFSC কোড",
    bankIfscPlaceholder: "যেমন HDFC0001234",
    bankDetailsHint: "আপনি যেকোনো সময় সেটিংস থেকে এটি যোগ বা পরিবর্তন করতে পারেন।",
    skipForNowLink: "এখন বাদ দিন",
    errValidIfsc: "সঠিক IFSC কোড লিখুন",
    finishBusy: "সেট আপ হচ্ছে…",
    finish: "শেষ করুন",
    doneTitle: "আপনি প্রস্তুত!",
    doneSub: "আপনার ড্যাশবোর্ড তৈরি।",
    goToDashboard: "ড্যাশবোর্ডে যান",
    welcomeBackToast: "আবার স্বাগতম, {name}!",
    welcomeNewToast: "ToLetBook-এ স্বাগতম, {name}!",
    orDivider: "অথবা",
    googleNoAccountToast: "সেই Google ইমেইলের জন্য কোনো ToLetBook অ্যাকাউন্ট পাওয়া যায়নি — চলুন আপনাকে সেট আপ করি।",
    forgotPasswordLink: "পাসওয়ার্ড ভুলে গেছেন?",
    forgotPasswordEyebrow: "পাসওয়ার্ড রিসেট করুন",
    forgotPasswordTitle: "আপনার পাসওয়ার্ড ভুলে গেছেন?",
    forgotPasswordSub: "আপনার ইমেইল লিখুন, আমরা এটি রিসেট করার জন্য একটি লিঙ্ক পাঠাব।",
    forgotPasswordSubmit: "রিসেট লিঙ্ক পাঠান",
    forgotPasswordBusy: "পাঠানো হচ্ছে…",
    forgotPasswordSentTitle: "আপনার ইমেইল দেখুন",
    forgotPasswordSentSub: "সেই ইমেইলের জন্য অ্যাকাউন্ট থাকলে, আমরা আপনার পাসওয়ার্ড রিসেট করার জন্য একটি লিঙ্ক পাঠিয়েছি।",
    resetPasswordEyebrow: "পাসওয়ার্ড রিসেট করুন",
    resetPasswordTitle: "নতুন পাসওয়ার্ড বেছে নিন",
    resetPasswordSub: "এই লিঙ্কটি 1 ঘণ্টার জন্য বৈধ।",
    newPasswordLabel: "নতুন পাসওয়ার্ড",
    confirmPasswordLabel: "নতুন পাসওয়ার্ড নিশ্চিত করুন",
    errPasswordMismatch: "পাসওয়ার্ড মিলছে না",
    resetPasswordSubmit: "পাসওয়ার্ড রিসেট করুন",
    resetPasswordBusy: "রিসেট হচ্ছে…",
    resetPasswordDoneTitle: "পাসওয়ার্ড রিসেট হয়েছে",
    resetPasswordDoneSub: "এখন আপনি আপনার নতুন পাসওয়ার্ড দিয়ে লগ ইন করতে পারেন।",
  },
  settings: {
    title: "সেটিংস",
    profileMenu: "প্রোফাইল",
    reportsMenu: "রিপোর্ট",
    plansMenu: "প্ল্যান ও বিলিং",
    referMenu: "রেফার করুন ও আয় করুন",
    appearance: "থিম",
    language: "ভাষা",
    dark: "ডার্ক",
    light: "লাইট",
    termsTitle: "নিয়ম ও শর্তাবলী",
    privacyTitle: "গোপনীয়তা নীতি",
    bankDetailsMenu: "আমার ব্যাংক বিবরণ",
    bankDetailsHint: "আপনাকে সরাসরি ভাড়া এবং ডিপোজিট পেমেন্ট পাঠাতে এই বিবরণগুলি ব্যবহার করা হয়। এগুলি ভাড়াটেদের কখনও দেখানো হয় না।",
    bankDetailsSaved: "ব্যাংক বিবরণ সেভ হয়েছে",
    contactUsMenu: "যোগাযোগ করুন",
    emailUsedToLogIn: "ইমেইল (লগ ইনের জন্য ব্যবহৃত)",
    name: "নাম",
    phone: "ফোন নম্বর",
    phonePlaceholder: "10 সংখ্যার মোবাইল নম্বর",
    city: "শহর",
    profileUpdated: "প্রোফাইল আপডেট হয়েছে",
    demoNotice: "এখানকার অ্যাকাউন্ট শুধু ডেমোর জন্য; যেকোনো ইমেইল ও পাসওয়ার্ড ব্যবহার করুন।",
    verificationTitle: "পরিচয় যাচাইকরণ",
    verificationHint: "আপনার প্রোফাইল ও লিস্টিংয়ে ভেরিফায়েড ব্যাজ পেতে সরকারি পরিচয়পত্র (সামনে ও পেছনে) আপলোড করুন।",
    verificationSubmit: "যাচাইয়ের জন্য জমা দিন",
    verificationSubmitted: "যাচাইয়ের জন্য জমা দেওয়া হয়েছে",
    errIdPhotosRequired: "আপনার পরিচয়পত্রের সামনে ও পেছনে উভয়ই যোগ করুন",
    verificationVerified: "আপনি যাচাইকৃত",
    verificationPending: "যাচাই মুলতুবি রয়েছে",
    verificationPendingSub: "পর্যালোচনা হয়ে গেলেই আমরা আপনাকে জানাব — সাধারণত এক-দুই দিনের মধ্যে।",
    verificationRejected: "যাচাই অনুমোদিত হয়নি",
    changePasswordTitle: "পাসওয়ার্ড পরিবর্তন করুন",
    currentPasswordLabel: "বর্তমান পাসওয়ার্ড",
    errCurrentPasswordRequired: "আপনার বর্তমান পাসওয়ার্ড লিখুন",
    passwordChanged: "পাসওয়ার্ড পরিবর্তিত হয়েছে",
    changePasswordButton: "পাসওয়ার্ড আপডেট করুন",
  },
  notifications: {
    title: "নোটিফিকেশন",
    enabledToast: "নোটিফিকেশন চালু করা হয়েছে",
    disabledToast: "নোটিফিকেশন বন্ধ করা হয়েছে",
    couldNotEnableToast: "নোটিফিকেশন চালু করা যায়নি",
    notConfigured: "এই সার্ভারে নোটিফিকেশন এখনো সেট আপ করা হয়নি",
    deniedHint: "আপনার ডিভাইস সেটিংসে এই অ্যাপের জন্য নোটিফিকেশন ব্লক করা আছে।",
    markAllRead: "সব পঠিত হিসেবে চিহ্নিত করুন",
    emptyState: "এখনো কোনো নোটিফিকেশন নেই।",
  },
  refer: {
    title: "রেফার করুন ও আয় করুন",
    heroTitle: "১ মাস দিন, ১ মাস পান",
    heroSub: "একজন বন্ধুকে ToLetBook-এ আমন্ত্রণ জানান। তারা অ্যাপ ডাউনলোড করে শুরু করলেই — মালিক হিসেবে তাদের প্রথম প্রপার্টি লিস্ট করুক, বা ভাড়াটে হিসেবে তাদের প্রথম কন্টাক্ট আনলক করুক — আপনারা দুজনেই ১ মাসের Pro বিনামূল্যে পাবেন।",
    yourCodeLabel: "আপনার রেফারেল কোড",
    shareButton: "আমন্ত্রণ শেয়ার করুন",
    copiedToast: "রেফারেল লিঙ্ক কপি হয়েছে",
    statsReferred: "{count} জনকে আমন্ত্রণ জানানো হয়েছে",
    statsRewarded: "{count} জন পুরস্কৃত হয়েছেন",
    statsRemaining: "{count} বিনামূল্যের মাস বাকি",
    howItWorksTitle: "এটি কীভাবে কাজ করে",
    step1: "আপনার কোড বা লিঙ্ক একজন বন্ধুর সাথে শেয়ার করুন",
    step2: "তারা ToLetBook ডাউনলোড করে সাইন আপ করে",
    step3: "তারা মালিক হিসেবে প্রথম প্রপার্টি লিস্ট করে, বা ভাড়াটে হিসেবে প্রথম কন্টাক্ট আনলক করে — আপনারা দুজনেই ১ মাসের Pro বিনামূল্যে পাবেন",
    historyTitle: "আপনার রেফারেলসমূহ",
    emptyState: "এখনো কোনো রেফারেল নেই — শুরু করতে আপনার কোড শেয়ার করুন",
    statusPending: "তাদের প্রথম লিস্টিংয়ের অপেক্ষায়",
    statusRewarded: "পুরস্কৃত হয়েছে — ১ মাস বিনামূল্যে",
    statusCapped: "তারা পুরস্কৃত হয়েছে — আপনার সীমা শেষ হয়ে গেছে",
    shareMessage: "আমার সাথে ToLetBook-এ যোগ দিন! সাইন আপ করার সময় আমার রেফারেল কোড {code} ব্যবহার করুন — আমরা দুজনেই ১ মাসের Pro বিনামূল্যে পাবো।",
  },
  ownerTerms: {
    intro: "ToLetBook ব্যবহার করে আপনি এই শর্তাবলীতে সম্মত হচ্ছেন।",
    bullet1: "ToLetBook-এর মাধ্যমে করা ভাড়া ও ডিপোজিটের পেমেন্ট Razorpay-এর মাধ্যমে প্রসেস করা হয়। ToLetBook কোনো ব্যাংক নয় এবং Razorpay-এর নিশ্চিতকরণের বাইরে কোনো ফলাফলের নিশ্চয়তা দেয় না।",
    bullet2: "আপনার দেওয়া প্রপার্টি, ভাড়াটে ও পেমেন্টের তথ্য সঠিক হওয়ার দায়িত্ব আপনার।",
    bullet3: "আপনার দেওয়া প্রপার্টি, ভাড়াটে ও পেমেন্টের তথ্য শুধু এই ডেমোর জন্যই সংরক্ষণ করা হয়, তৃতীয় পক্ষের সাথে শেয়ার করা হয় না।",
    bullet4: "রিপোর্ট ও নোটবুকের সংখ্যাগুলো আপনার দেওয়া তথ্য থেকে সরাসরি হিসাব করা — অডিট বা যাচাই করা হয়নি।",
    bullet5: "ম্যাপ ও লোকেশন ফিচারগুলো Google Maps দ্বারা প্রদান করা হয়, যা Google-এর নিজস্ব শর্তাবলীর অধীন।",
  },
  tenantTerms: {
    intro: "ToLetBook ব্যবহার করে আপনি এই শর্তাবলীতে সম্মত হচ্ছেন।",
    bullet1: "ToLetBook-এর মাধ্যমে করা ভাড়া ও ডিপোজিটের পেমেন্ট Razorpay-এর মাধ্যমে প্রসেস করা হয়। ToLetBook কোনো ব্যাংক নয় এবং Razorpay-এর নিশ্চিতকরণের বাইরে কোনো ফলাফলের নিশ্চয়তা দেয় না।",
    bullet2: "আপনার দেওয়া তথ্য সঠিক হওয়ার দায়িত্ব আপনার।",
    bullet3: "আপনার দেওয়া প্রপার্টি, ভাড়াটে ও পেমেন্টের তথ্য শুধু এই ডেমোর জন্যই সংরক্ষণ করা হয়, তৃতীয় পক্ষের সাথে শেয়ার করা হয় না।",
    bullet4: "দেখানো সংখ্যাগুলো আপনি বা আপনার মালিকের দেওয়া তথ্য থেকে সরাসরি হিসাব করা — অডিট বা যাচাই করা হয়নি।",
    bullet5: "ম্যাপ ও লোকেশন ফিচারগুলো Google Maps দ্বারা প্রদান করা হয়, যা Google-এর নিজস্ব শর্তাবলীর অধীন।",
  },
  ownerHome: {
    sectionTitlePg: "আপনার পিজি",
    sectionTitleProperties: "আপনার প্রপার্টি",
    thisMonth: "এই মাসে",
    pctCollected: "{pct}% সংগ্রহ হয়েছে",
    received: "পাওয়া গেছে",
    pending: "বাকি",
    remindAll: "সবাইকে রিমাইন্ড করুন",
    remindersSent: "{count} জন ভাড়াটেকে রিমাইন্ডার পাঠানো হয়েছে",
    couldNotSendReminders: "রিমাইন্ডার পাঠানো যায়নি",
    bedOccupancy: "বেড অকুপেন্সি",
    bedsFraction: "{filled}/{total} বেড",
    acrossPg: "মোট {count} পিজি {unit}",
    pgUnitSingular: "প্রপার্টি",
    pgUnitPlural: "প্রপার্টি",
    totalCount: "মোট {count}",
    addPropertyAria: "প্রপার্টি যোগ করুন",
    addUnitFab: "ইউনিট যোগ করুন",
    sendWhatsappReceiptBtn: "WhatsApp রসিদ পাঠান",
    directUpiPayLinkBtn: "ডাইরেক্ট UPI পে লিংক",
    whatsappReceiptMessage: "হাই {tenant}, {property}-এর জন্য আপনার ভাড়ার রসিদ: {amount} ({status})। - {owner}, ToLetBook এর মাধ্যমে",
    upiPayLinkMessage: "হাই {tenant}, দয়া করে {property}-এর এই মাসের ভাড়া ({amount}) UPI-এর মাধ্যমে দিন: {link} - {owner}, ToLetBook এর মাধ্যমে",
    noTenantPhone: "এই ভাড়াটের ফোন নম্বর নথিভুক্ত নেই",
    noUpiIdSet: "প্রথমে সেটিংসে আপনার UPI ID যোগ করুন",
    tabProperty: "প্রপার্টি",
    tabPg: "পিজি",
    emptyNoProperties: "এখনো কোনো প্রপার্টি নেই। প্রথমটি যোগ করতে + এ ট্যাপ করুন।",
    emptyNoIndependent: "এখনো কোনো ইন্ডিপেন্ডেন্ট প্রপার্টি নেই।",
    emptyNoPg: "এখনো কোনো পিজি প্রপার্টি নেই।",
    emptyNoCommercial: "এখনো কোনো কমার্শিয়াল প্রপার্টি নেই।",
    filterAll: "সব",
    filterResidential: "রেসিডেনশিয়াল",
    filterCommercial: "কমার্শিয়াল",
    filterPg: "PG / হোস্টেল",
    sqftSuffix: "বর্গফুট",
    listedOnMarketplace: "মার্কেটপ্লেসে লিস্ট করা হয়েছে",
    removedFromMarketplace: "মার্কেটপ্লেস থেকে সরানো হয়েছে",
    couldNotUpdateListing: "লিস্টিং আপডেট করা যায়নি",
    rentUpdated: "ভাড়া আপডেট হয়েছে",
    couldNotUpdateRent: "ভাড়া আপডেট করা যায়নি",
    maintenanceUpdated: "মেইনটেন্যান্স আপডেট হয়েছে",
    couldNotUpdateMaintenance: "মেইনটেন্যান্স আপডেট করা যায়নি",
    paid: "পেমেন্ট হয়েছে",
    tenantLabel: "ভাড়াটে",
    perMonth: "/মাস",
    phoneLabel: "ফোন",
    noPhoneOnFile: "ফোন নম্বর দেওয়া নেই",
    aadhaarLabel: "আধার",
    depositLabel: "ডিপোজিট",
    moveInDateLabel: "মুভ-ইন তারিখ",
    hideManageOptions: "ম্যানেজ অপশন লুকান",
    manage: "ম্যানেজ করুন",
    manageHouses: "বাড়ি ম্যানেজ করুন",
    rentalAgreement: "রেন্টাল এগ্রিমেন্ট",
    rentalReceipts: "রেন্টাল রসিদ",
    modifyRent: "ভাড়া পরিবর্তন করুন",
    maintenanceMenu: "মেইনটেন্যান্স",
    removeTenant: "ভাড়াটে সরান",
    newRentLabel: "নতুন ভাড়া / মাস",
    save: "সেভ করুন",
    maintenancePerMonthLabel: "মেইনটেন্যান্স / মাস",
    vacantBadge: "খালি",
    expectedRentLabel: "প্রত্যাশিত ভাড়া",
    depositSuffix: " · ডিপোজিট {amount}",
    maintenanceLine: "+ {amount}/মাস মেইনটেন্যান্স",
    listOnToLet: "TO-LET মার্কেটপ্লেসে লিস্ট করুন",
    liveVisible: "লাইভ · ভাড়াটেদের কাছে দৃশ্যমান",
    notListedYet: "এখনো লিস্ট করা হয়নি",
    toggleToLetAria: "TO-LET টগল করুন",
    addTenantButton: "ভাড়াটে যোগ করুন",
    occBoys: "ছেলেদের পিজি",
    occGirls: "মেয়েদের পিজি",
    occCoEd: "কো-এড পিজি",
    occDefault: "পিজি",
    listVacantBedsToLet: "খালি বেড TO-LET-এ লিস্ট করুন",
    fullyOccupied: "সম্পূর্ণ ভরা · কোনো বেড খালি নেই",
  },
  ownerListings: {
    propertyAdded: "প্রপার্টি যোগ করা হয়েছে",
    upgradeToastMsg: "আপনি আপনার প্ল্যানের লিস্টিং সীমায় পৌঁছে গেছেন — আপগ্রেড অপশনে পাঠানো হচ্ছে।",
    heading: "আমার প্রপার্টি",
    addLink: "+ যোগ করুন ›",
    emptyState: "এখনো কোনো প্রপার্টি নেই — প্রথমটি যোগ করুন।",
    confirmDelete: '"{label}" ডিলিট করবেন? এটা ফিরিয়ে আনা যাবে না।',
    propertyDeleted: "প্রপার্টি ডিলিট হয়েছে",
    confirmDeleteHouse: '"{label}" সরাবেন? এটি ফিরিয়ে আনা যাবে না।',
    houseRemoved: "বাড়ি সরানো হয়েছে",
    houseUpdated: "বাড়ির তথ্য আপডেট হয়েছে",
    listedOnMarketplace: "মার্কেটপ্লেসে লিস্ট করা হয়েছে",
    removedFromMarketplace: "মার্কেটপ্লেস থেকে সরানো হয়েছে",
    couldNotUpdateListing: "লিস্টিং আপডেট করা যায়নি",
    vacantBedsFraction: "{vacant} / {total} খালি",
    listOnToLet: "TO-LET মার্কেটপ্লেসে লিস্ট করুন",
    listVacantBedsToLet: "খালি বেড TO-LET-এ লিস্ট করুন",
    liveVisible: "লাইভ · ভাড়াটেদের কাছে দৃশ্যমান",
    notListedYet: "এখনো লিস্ট করা হয়নি",
    toggleToLetAria: "TO-LET টগল করুন",
    moreOptionsAria: "আরও অপশন",
    editDetails: "বিস্তারিত এডিট করুন",
    deleteProperty: "প্রপার্টি ডিলিট করুন",
    expectedRentLabel: "প্রত্যাশিত ভাড়া",
    depositLabel: "ডিপোজিট",
    noPhoneOnFile: "ফোন নম্বর দেওয়া নেই",
    perMonth: "/মাস",
    endTenancyButton: "টেনেন্সি শেষ করুন",
    editTenantButton: "ভাড়াটে মডিফাই করুন",
    saveTenantButton: "পরিবর্তন সেভ করুন",
    tenantAdded: "ভাড়াটে যোগ করা হয়েছে",
    tenantUpdated: "ভাড়াটের তথ্য আপডেট হয়েছে",
    roomAdded: "রুম যোগ করা হয়েছে",
    couldNotAddRoom: "রুম যোগ করা যায়নি",
    addTenantLink: "+ ভাড়াটে যোগ করুন",
    installAppPromptTitle: "{name} এখনও ToLetBook ইনস্টল করেননি",
    installAppPromptBody: "অ্যাপ শেয়ার করুন যাতে তিনি নিজের এগ্রিমেন্ট দেখতে পারেন এবং মুভ-ইন তথ্য সম্পূর্ণ করতে পারেন।",
    notifyTenantPromptTitle: "WhatsApp-এ {name} কে জানান",
    notifyTenantPromptBody: "এটি শেয়ার করুন যাতে তিনি অ্যাপ খুলে মুভ-ইন তথ্য সম্পূর্ণ করতে পারেন।",
    shareOnWhatsappBtn: "💬 WhatsApp-এ শেয়ার করুন",
    installAppWhatsappMessage: "নমস্কার, আমি ToLetBook থেকে {owner}। আমি আপনাকে \"{property}\" এর জন্য ভাড়াটে হিসেবে যোগ করেছি। আপনার ভাড়া, এগ্রিমেন্ট দেখতে এবং মুভ-ইন তথ্য সম্পূর্ণ করতে দয়া করে অ্যাপ ইনস্টল করুন: {link}",
    notifyTenantWhatsappMessage: "নমস্কার, আমি ToLetBook থেকে {owner}। আমি আপনাকে \"{property}\" এর জন্য ভাড়াটে হিসেবে যোগ করেছি। আপনার ভাড়া, এগ্রিমেন্ট দেখতে এবং মুভ-ইন তথ্য সম্পূর্ণ করতে দয়া করে অ্যাপ খুলুন: {link}",
    editButton: "এডিট করুন",
    deleteButton: "ডিলিট করুন",
    perBed: "{amount}/বেড",
    priceTiers: "{count} প্রাইস টায়ার",
    occupiedFraction: "{occupied}/{total} ভরা",
    occupiedBadge: "ভরা",
    vacantBadge: "খালি",
    rentalAgreementButton: "রেন্টাল এগ্রিমেন্ট",
    rentalReceiptsButton: "ভাড়ার রসিদ",
    noReceiptsYet: "এখনও কোনো পরিশোধিত রসিদ নেই।",
    receiptsBackLink: "‹ ফিরে যান",
    loadingReceipts: "লোড হচ্ছে…",
  },
  assignTenantForm: {
    contactPickerUnsupported: "এই ডিভাইস/ব্রাউজারে কন্টাক্ট পিকার সাপোর্ট করে না",
    errNameRequired: "ভাড়াটের নাম আবশ্যক",
    newTenant: "নতুন ভাড়াটে",
    existingTenant: "বিদ্যমান ভাড়াটে",
    addFromContacts: "কন্টাক্ট থেকে যোগ করুন",
    emptyExistingTenants: "আপনার প্রপার্টিতে এখনো অন্য কোনো ভাড়াটে নেই।",
    noPhoneOnFile: "ফোন নম্বর দেওয়া নেই",
    tenantNameLabel: "ভাড়াটের নাম",
    phoneLabel: "ফোন (রেজিস্টার করা থাকলে তাদের ToLetBook অ্যাকাউন্টের সাথে মিলবে)",
    phonePlaceholder: "10 সংখ্যার নম্বর",
    aadhaarLabel: "আধার (ঐচ্ছিক)",
    aadhaarPhotosLabel: "আধার ছবি (ঐচ্ছিক)",
    aadhaarFront: "সামনে",
    aadhaarBack: "পিছনে",
    removeAadhaarPhotoAria: "ছবি সরান",
    rentLabel: "ভাড়া / মাস",
    depositLabel: "ডিপোজিট",
    dateOfOccupancyLabel: "থাকা শুরুর তারিখ",
    dateHint: "যদি তারা ইতিমধ্যে এখানে থাকেন, তাহলে তারা আসলে কবে মুভ-ইন করেছিলেন সেই তারিখ বেছে নিন — আজকের তারিখ নয়।",
    rentDueDayLabel: "ভাড়া দেওয়ার তারিখ",
    rentDueDayHint: "মাসের যে দিনে ভাড়া দিতে হবে (1–31)। ডিফল্টভাবে থাকা শুরুর তারিখ থাকে।",
    noticePeriodLabel: "নোটিস পিরিয়ড (দিন)",
    noticePeriodHint: "ভাড়াটেকে খালি করার আগে কত দিনের নোটিস দিতে হবে। ডিফল্টভাবে 60 দিন (2 মাস) থাকে।",
    addTenantButton: "ভাড়াটে যোগ করুন",
  },
  addPropertyForm: {
    errNameRequired: "প্রপার্টির একটা নাম দিন",
    errLocalityRequired: "এলাকা লিখুন",
    errCityRequired: "শহর লিখুন",
    errStateRequired: "রাজ্য নির্বাচন করুন",
    errPincodeRequired: "পিনকোড লিখুন",
    errFurnishingRequired: "ফার্নিশিং অবস্থা নির্বাচন করুন",
    errCommunityTypeRequired: "কমিউনিটি টাইপ নির্বাচন করুন",
    errRentRequired: "প্রত্যাশিত ভাড়া লিখুন",
    errDepositRequired: "প্রত্যাশিত ডিপোজিট লিখুন",
    upgradeNowBtn: "এখনই আপগ্রেড করুন",
    heading: "প্রপার্টি যোগ করুন",
    localityLabel: "এলাকা",
    localityPlaceholder: "যেমন ইন্দিরানগর, বেঙ্গালুরু",
    cityLabel: "শহর",
    cityPlaceholder: "যেমন বেঙ্গালুরু",
    stateLabel: "রাজ্য",
    statePlaceholder: "রাজ্য নির্বাচন করুন",
    pincodeLabel: "পিনকোড",
    pincodePlaceholder: "৬-সংখ্যার পিনকোড",
    chipIndependent: "ইন্ডিপেন্ডেন্ট",
    chipPgHostel: "পিজি / হোস্টেল",
    chipCommercial: "কমার্শিয়াল",
    propertyNameLabel: "প্রপার্টির নাম",
    propertyNamePlaceholder: "যেমন 3, রোজউড অ্যাপার্টমেন্টস",
    typeLabel: "ধরন",
    expectedRentLabel: "প্রত্যাশিত ভাড়া",
    expectedDepositLabel: "প্রত্যাশিত ডিপোজিট",
    maintenanceLabel: "মেইনটেন্যান্স / মাস (ঐচ্ছিক)",
    maintenancePlaceholder: "যেমন 1500",
    multiUnitChip: "এই প্রপার্টিতে একাধিক বাড়ি আছে",
    multiUnitHint: "যে কম্পাউন্ড বা বিল্ডিংয়ে ভাড়ার জন্য একাধিক আলাদা বাড়ি/ফ্ল্যাট আছে তার জন্য — প্রতিটির নিজস্ব ভাড়া, ডিপোজিট ও ভাড়াটে থাকবে।",
    commercialDetailsHeading: "কমার্শিয়াল বিবরণ",
    carpetAreaLabel: "কার্পেট এরিয়া (বর্গফুট)",
    builtUpAreaLabel: "বিল্ট-আপ এরিয়া (বর্গফুট)",
    lockInMonthsLabel: "লক-ইন সময়কাল (মাস)",
    rentEscalationPercentLabel: "ভাড়া বৃদ্ধি (%)",
    rentEscalationYearsLabel: "কত বছর পরপর বৃদ্ধি",
    possessionStatusLabel: "দখল স্থিতি",
    possession_ready: "সাথে সাথে উপলব্ধ",
    possession_under_fitout: "ফিট-আউট চলছে",
    washroomTypeLabel: "ওয়াশরুম",
    washroom_attached: "সংযুক্ত",
    washroom_shared: "শেয়ার্ড",
    commercialAmenitiesLabel: "সুবিধা",
    powerBackupChip: "পাওয়ার ব্যাকআপ",
    powerLoadDetailsLabel: "পাওয়ার ব্যাকআপ বিবরণ (ঐচ্ছিক)",
    powerLoadDetailsPlaceholder: "যেমন 3-ফেজ, 100% DG ব্যাকআপ",
    parkingSpotsLabel: "সংরক্ষিত পার্কিং (গাড়ি/বাইক)",
    gstChip: "ভাড়ায় 18% GST প্রযোজ্য",
    frontageChip: "ফ্রন্টেজ / সাইনেজ অধিকার",
    seatsCountLabel: "সিট",
    cabinsCountLabel: "কেবিন",
    meetingRoomsCountLabel: "মিটিং রুম",
    housesHeading: "বাড়ি",
    addHouseLink: "+ বাড়ি যোগ করুন ›",
    houseNameLabel: "বাড়ির নাম",
    hasExistingTenantChip: "এই প্রপার্টিতে ইতিমধ্যে একজন ভাড়াটে আছেন",
    tenantNameLabel: "ভাড়াটের নাম",
    phoneLabel: "ফোন (রেজিস্টার করা থাকলে তাদের ToLetBook অ্যাকাউন্টের সাথে মিলবে)",
    phonePlaceholder: "10 সংখ্যার নম্বর",
    aadhaarLabel: "আধার (ঐচ্ছিক)",
    dateOfOccupancyLabel: "থাকা শুরুর তারিখ",
    dateHint: "তারা আসলে কবে মুভ-ইন করেছিলেন — ভাড়া ও ডিপোজিটে উপরের প্রত্যাশিত মান ব্যবহার হবে।",
    occupancyLabel: "অকুপেন্সি",
    occBoys: "ছেলেরা",
    occGirls: "মেয়েরা",
    occCoEd: "কো-এড",
    roomsHeading: "রুম",
    addRoomLink: "+ রুম যোগ করুন ›",
    sharingTypeLabel: "শেয়ারিং টাইপ",
    rentPerBedLabel: "ভাড়া/বেড",
    depositPerBedLabel: "ডিপোজিট/বেড",
    bedsLabel: "বেড",
    mealPlanLabel: "খাবার অন্তর্ভুক্ত",
    preferredTenantsLabel: "পছন্দের ভাড়াটে",
    meal_breakfast: "ব্রেকফাস্ট",
    meal_lunch: "লাঞ্চ",
    meal_dinner: "ডিনার",
    tenantType_student: "শিক্ষার্থী",
    tenantType_professional: "কর্মজীবী",
    roomAc: "এসি",
    roomAttachedBathroom: "অ্যাটাচড বাথরুম",
    addPropertyButton: "প্রপার্টি যোগ করুন",
  },
  ownerLedgers: {
    justNow: "এইমাত্র",
    minsAgo: "{mins} মিনিট আগে",
    hoursAgo: "{hours} ঘণ্টা আগে",
    daysAgo: "{days} দিন আগে",
    emptyNoProperty: "নোটবুক ট্র্যাক করতে প্রথমে একটি প্রপার্টি যোগ করুন।",
    heading: "নোটবুক",
    emptyNoTenants: "এখানে এখনো কোনো ভাড়াটে নেই।",
    markedPaid: "পেমেন্ট হয়েছে বলে মার্ক করা হয়েছে",
    reminderSent: "ভাড়াটেকে রিমাইন্ডার পাঠানো হয়েছে",
    emptyNoActiveTenants: "এখানে এখনো কোনো অ্যাক্টিভ ভাড়াটে নেই।",
    otherCategory: "অন্যান্য",
    pastTenantsHeading: "আগের ভাড়াটে · {count}",
    rentLedgerLabel: "ভাড়ার লেজার · গত 12 মাস",
    paidFraction: "{paid}/{total} পেমেন্ট হয়েছে",
    entriesLabel: "এন্ট্রি",
    rentPaid: "ভাড়া পাওয়া গেছে",
    rentDue: "ভাড়া বাকি",
    markReceived: "পাওয়া গেছে মার্ক করুন (নগদ)",
    markingBusy: "মার্ক হচ্ছে…",
    remindAgain: "🔔 আবার রিমাইন্ড করুন",
    remind: "🔔 রিমাইন্ড করুন",
    sendingBusy: "পাঠানো হচ্ছে…",
    remindedAgo: "{time} রিমাইন্ড করা হয়েছে",
    closeButton: "‹ বন্ধ করুন",
    refundLabel: "রিফান্ড",
    refundedAmount: "{amount} রিফান্ড করা হয়েছে",
  },
  ownerReports: {
    emptyState: "এখনো লেজারে কোনো কার্যকলাপ নেই — সংগ্রহ শুরু করতে একজন ভাড়াটে যোগ করুন।",
    heading: "রিপোর্ট",
    collected: "সংগ্রহ হয়েছে",
    pending: "বাকি",
    paidOnRecord: "রেকর্ডে পেমেন্ট",
    collectionsByMonth: "মাস অনুযায়ী সংগ্রহ",
    monthTooltip: "{month}: {collected} সংগ্রহ হয়েছে, {pending} বাকি",
    byProperty: "প্রপার্টি অনুযায়ী",
    pendingAmount: "{amount} বাকি",
    exportCsvButton: "লেজার CSV হিসেবে এক্সপোর্ট করুন",
    hint: "প্রতিটি সারি একটি লেজার এন্ট্রি থেকে এসেছে — এখানে আলাদা করে কোনো সংখ্যা যোগ করা হয়নি।",
  },
  ownerRequests: {
    visitRequestsHeading: "ভিজিট রিকোয়েস্ট",
    newCount: "{count}টি নতুন",
    emptyNoVisits: "এখনো কোনো ভিজিট রিকোয়েস্ট নেই।",
    maintenanceRequestsHeading: "মেইনটেন্যান্স রিকোয়েস্ট",
    emptyNoRequests: "এখনো কোনো রিকোয়েস্ট পাঠানো হয়নি।",
    noDetailsProvided: "কোনো বিস্তারিত দেওয়া হয়নি",
    startWork: "কাজ শুরু করুন",
    markResolved: "সমাধান হয়েছে মার্ক করুন",
    requestUpdated: "রিকোয়েস্ট আপডেট হয়েছে",
    visitConfirmed: "ভিজিট কনফার্ম হয়েছে",
    visitDeclined: "ভিজিট বাতিল করা হয়েছে",
    noPhoneOnFile: "ফোন নম্বর দেওয়া নেই",
    visitLine: "{property} · {date}, {time}",
    declineButton: "বাতিল করুন",
    confirmButton: "কনফার্ম করুন",
    statusOpen: "খোলা",
    statusInProgress: "চলছে",
    statusResolved: "সমাধান হয়েছে",
    visitStatusPending: "পেন্ডিং",
    visitStatusConfirmed: "কনফার্ম হয়েছে",
    visitStatusDeclined: "বাতিল হয়েছে",
    visitStatusCancelled: "ক্যানসেল হয়েছে",
    vacateRequestsHeading: "খালি করার নোটিস",
    emptyNoVacates: "এখনো কোনো খালি করার নোটিস নেই।",
    vacateLine: "{property} · {date} তারিখে খালি হবে",
    noticeGivenLine: "{date} তারিখে নোটিস দেওয়া হয়েছে",
    acknowledgeButton: "গ্রহণ করুন",
    vacateAcknowledged: "খালি করার নোটিস গ্রহণ করা হয়েছে",
    vacateStatusPending: "পেন্ডিং",
    vacateStatusAcknowledged: "গৃহীত",
    vacateStatusCancelled: "ক্যানসেল হয়েছে",
  },
  editPropertyForm: {
    errNameRequired: "প্রপার্টির একটা নাম দিন",
    propertyUpdated: "প্রপার্টি আপডেট হয়েছে",
    couldNotUpdate: "প্রপার্টি আপডেট করা যায়নি",
    localityLabel: "এলাকা",
    propertyNameLabel: "প্রপার্টির নাম",
    typeLabel: "ধরন",
    residentialGroup: "রেসিডেনশিয়াল",
    commercialGroup: "কমার্শিয়াল",
    expectedRentLabel: "প্রত্যাশিত ভাড়া",
    expectedDepositLabel: "প্রত্যাশিত ডিপোজিট",
    maintenanceLabel: "মেইনটেন্যান্স / মাস (ঐচ্ছিক)",
    occupancyLabel: "অকুপেন্সি",
    occBoys: "ছেলেরা",
    occGirls: "মেয়েরা",
    occCoEd: "কো-এড",
    facilitiesLabel: "সুযোগ-সুবিধা",
    facility_wifi: "ওয়াই-ফাই",
    facility_meals: "খাবার",
    facility_laundry: "লন্ড্রি",
    facility_powerBackup: "পাওয়ার ব্যাকআপ",
    facility_cctv: "সিসিটিভি",
    facility_parking: "পার্কিং",
    facility_ac: "এসি",
    facility_tv: "টিভি",
    facility_washingMachine: "ওয়াশিং মেশিন",
    perHouseFurnishingHint: "ফার্নিশিং প্রতিটি বাড়ির জন্য আলাদাভাবে সেট করা হয় — নিচে প্রতিটি বাড়ি খুলে সেট করুন।",
    furnishingStatusLabel: "ফার্নিশিং",
    furnishing_unfurnished: "আনফার্নিশড",
    furnishing_semi_furnished: "সেমি-ফার্নিশড",
    furnishing_fully_furnished: "ফুলি ফার্নিশড",
    commercialFurnishing_unfurnished: "বেয়ার শেল",
    commercialFurnishing_semi_furnished: "ওয়ার্ম শেল",
    commercialFurnishing_fully_furnished: "ফুলি ফার্নিশড",
    communityTypeLabel: "কমিউনিটি টাইপ",
    community_gated: "গেটেড কমিউনিটি",
    community_semi_gated: "সেমি গেটেড কমিউনিটি",
    community_villa: "ভিলা",
    community_apartment: "অ্যাপার্টমেন্ট",
    community_independent: "ইন্ডিপেন্ডেন্ট",
    floorNumberLabel: "তলা",
    floorNumberPlaceholder: "যেমন 3 বা গ্রাউন্ড",
    floorChipLabel: "তলা {floor}",
    furnishingItemsLabel: "ফার্নিচার ও যন্ত্রপাতি",
    furnishingItemsHint: "প্রতিটা জিনিস ভাড়াটে কতগুলো পাবে তা লিখুন।",
    item_fan: "ফ্যান",
    item_light: "লাইট",
    item_ac: "এসি",
    item_fridge: "ফ্রিজ",
    item_washingMachine: "ওয়াশিং মেশিন",
    item_sofa: "সোফা",
    item_bed: "বেড",
    item_heater: "ওয়াটার হিটার (বাথরুম)",
    item_chimney: "চিমনি (কিচেন)",
    addFurnitureItemPlaceholder: "+ আসবাবপত্র / যন্ত্রপাতি যোগ করুন",
    customItemNamePlaceholder: "যেমন স্টাডি টেবিল",
    addCustomItemBtn: "+ আরেকটি জিনিস যোগ করুন",
  },
  endTenancyForm: {
    tenancyEnded: "টেনেন্সি শেষ হয়েছে — রিফান্ডের বিস্তারিত ভাড়াটেকে পাঠানো হয়েছে",
    couldNotEnd: "টেনেন্সি শেষ করা যায়নি",
    heading: "টেনেন্সি শেষ করুন — {name}",
    dateOfExitLabel: "ছাড়ার তারিখ",
    depositPaidLabel: "জমা দেওয়া ডিপোজিট",
    deductionsLabel: "কর্তন (ক্ষতি, বাকি টাকা ইত্যাদি)",
    deductionNoteLabel: "কর্তনের নোট (ঐচ্ছিক)",
    deductionNotePlaceholder: "যেমন দেয়ালের রং ঠিক করা",
    refundableDepositLabel: "ফেরতযোগ্য ডিপোজিট",
    confirmButton: "কনফার্ম করে টেনেন্সি শেষ করুন",
    endingBusy: "শেষ হচ্ছে…",
  },
  propertyPhotos: {
    uploadFailed: "আপলোড ব্যর্থ হয়েছে",
    photoRemoved: "ছবি সরানো হয়েছে",
    couldNotRemove: "ছবি সরানো যায়নি",
    removePhotoAria: "ছবি সরান",
  },
  photoStager: {
    photosLabel: "ছবি (ঐচ্ছিক)",
    couldNotRead: "সেই ছবিটি পড়া যায়নি",
    removePhotoAria: "ছবি সরান",
  },
  photoPickerButtons: {
    addPhotoTitle: "একটি ছবি যোগ করুন",
    takePhoto: "📷 ছবি তুলুন",
    chooseFromFiles: "🖼 ফাইল থেকে বেছে নিন",
  },
  ownerPlans: {
    title: "প্ল্যান",
    currentPlanLabel: "বর্তমান প্ল্যান",
    trialBadge: "ফ্রি প্রিমিয়াম ট্রায়াল",
    trialEndsOn: "ট্রায়াল {date} তারিখে শেষ হবে",
    renewsOn: "{date} তারিখে নবায়ন হবে",
    listingsUsed: "{cap}-এর মধ্যে {used}টি লিস্টিং ব্যবহৃত",
    billingMonthly: "মাসিক",
    billingYearly: "বার্ষিক · ~16% সাশ্রয়",
    basicName: "বেসিক",
    proName: "প্রো",
    premiumName: "প্রিমিয়াম",
    mostPopular: "সবচেয়ে জনপ্রিয়",
    powerOwners: "পাওয়ার মালিকদের জন্য",
    basicSub: "যারা সবে শুরু করছেন এমন মালিকদের জন্য",
    proSub: "কয়েকটি প্রপার্টি আছে এমন মালিকদের জন্য",
    premiumSub: "একাধিক প্রপার্টি পরিচালনাকারী মালিকদের জন্য",
    featListing1: "1টি সক্রিয় লিস্টিং",
    featListing3: "3টি পর্যন্ত সক্রিয় লিস্টিং",
    featListingUnlimited: "সীমাহীন লিস্টিং",
    featEnquiries: "ভাড়াটে জিজ্ঞাসা এবং ভিজিট রিকোয়েস্ট",
    featLedger: "ভাড়া সংগ্রহ এবং ডিজিটাল লেজার",
    featAgreement: "সেল্ফ-সার্ভ রেন্টাল অ্যাগ্রিমেন্ট জেনারেটর — শীঘ্রই আসছে",
    featMarketplace: "TO-LET মার্কেটপ্লেসে দৃশ্যমান",
    featEverythingBasic: "বেসিকের সব কিছু",
    featEverythingPro: "প্রো-র সব কিছু",
    featMarketplaceSwitch: "TO-LET মার্কেটপ্লেস সুইচ — যেকোনো সময় লাইভ করুন",
    featFeatured: "সার্চে ফিচার্ড প্লেসমেন্ট",
    featPriority: "একই ধরনের প্রপার্টি সাজেশনে অগ্রাধিকার",
    featTopListing: "টপ লিস্টিং — মার্কেটপ্লেস সার্চের একদম উপরে পিন করা",
    featPriorityAgreement: "অগ্রাধিকার রেন্টাল অ্যাগ্রিমেন্ট সেবা (আইনগতভাবে পর্যালোচিত, দ্রুত টার্নঅ্যারাউন্ড) — শীঘ্রই আসছে",
    featPriorityVerification: "অগ্রাধিকার পরিচয়-যাচাইকরণ পর্যালোচনা",
    featPrioritySupport: "অগ্রাধিকার সাপোর্ট",
    currentPlanBtn: "বর্তমান প্ল্যান",
    switchToBtn: "{plan}-এ পরিবর্তন করুন",
    noChargeNote: "এখনও কোনো পেমেন্ট প্রয়োজন নেই — বিলিং সেটআপ না হওয়া পর্যন্ত প্ল্যান পরিবর্তন করা বিনামূল্যে।",
    switchedToast: "{plan} প্ল্যানে পরিবর্তন করা হয়েছে",
    switchFailedToast: "প্ল্যান পরিবর্তন করা যায়নি",
    trialActiveNote: "আপনি একটি ফ্রি প্রিমিয়াম ট্রায়ালে আছেন — এটি শেষ না হওয়া পর্যন্ত প্রতিটি প্রিমিয়াম ফিচার আনলক করা আছে।",
    cancelPlanBtn: "প্ল্যান বাতিল করুন",
    securePaymentNote: "Razorpay-এর মাধ্যমে পেমেন্ট নিরাপদে প্রসেস করা হয়।",
  },
  tenantHome: {
    moveOutSettlement: "মুভ-আউট সেটেলমেন্ট",
    yourLastPlace: "আপনার আগের ঠিকানা",
    depositPaid: "জমা দেওয়া ডিপোজিট",
    deductionsLabel: "কর্তন",
    refundableDeposit: "ফেরতযোগ্য ডিপোজিট",
    exitedOn: "{date} তারিখে ছেড়েছেন",
    noActiveTenancyLine1: "এখনো আপনার কোনো অ্যাক্টিভ টেনেন্সি নেই।",
    noActiveTenancyLine2: "থাকার জায়গা খুঁজতে লিস্টিং দেখুন, অথবা মুভ-ইন করার পর আপনার মালিককে আপনাকে যোগ করতে বলুন।",
    welcomeTitle: "ToLetBook-এ স্বাগতম!",
    welcomeSub: "আপনার জন্য ভাড়ার প্রপার্টি খুঁজি।",
    browsePropertiesBtn: "প্রপার্টি দেখুন",
    rentForMonth: "{month}-এর ভাড়া",
    paidStatus: "পেমেন্ট হয়েছে",
    dueStatus: "বাকি",
    overdueStatus: "ওভারডিউ",
    dueInDays: "{count} দিনের মধ্যে দিতে হবে",
    dueTodayLabel: "আজ দিতে হবে",
    overdueByDays: "{count} দিন ওভারডিউ",
    reminderBanner: "🔔 আপনার মালিক এই পেমেন্ট নিয়ে একটি রিমাইন্ডার পাঠিয়েছেন",
    paidCheck: "✓ পেমেন্ট হয়েছে",
    onDate: "{date} তারিখে",
    viaMode: "{mode}-এর মাধ্যমে",
    receiptBtn: "রসিদ",
    payingBtn: "পেমেন্ট হচ্ছে…",
    payAmount: "{amount} দিন",
    paymentRecordedToast: "পেমেন্ট রেকর্ড হয়েছে",
    ownerLabel: "মালিক",
    callOwnerAria: "মালিককে কল করুন",
    raiseRequest: "রিকোয়েস্ট পাঠান",
    viewLease: "এগ্রিমেন্ট দেখুন",
    receiptsNav: "রসিদ",
    browseRooms: "রুম দেখুন",
    openRequestsHeading: "খোলা রিকোয়েস্ট",
    viewAll: "সব দেখুন",
    noOpenRequests: "কোনো খোলা রিকোয়েস্ট নেই।",
    noDetailsProvided: "কোনো বিস্তারিত দেওয়া হয়নি",
  },
  tenantBrowse: {
    occBoys: "ছেলেদের পিজি",
    occGirls: "মেয়েদের পিজি",
    occCoEd: "কো-এড পিজি",
    occDefault: "পিজি",
    filterAll: "সব",
    filterPg: "পিজি",
    filter1RK: "1RK",
    filter1BHK: "1BHK",
    filter2BHK: "2BHK",
    filter3BHK: "3BHK",
    filterVilla: "ভিলা",
    filterShop: "দোকান",
    filterOffice: "অফিস",
    filterShowroom: "শোরুম",
    filterWarehouse: "গুদাম",
    filterCoworking: "কো-ওয়ার্কিং",
    filterFactory: "ফ্যাক্টরি",
    sortDefault: "ডিফল্ট",
    sortPriceAsc: "দাম: কম থেকে বেশি",
    sortPriceDesc: "দাম: বেশি থেকে কম",
    sortDistance: "দূরত্ব: সবচেয়ে কাছে",
    locationNotSupported: "এই ব্রাউজারে লোকেশন সাপোর্ট করে না",
    locationPermissionDenied: "লোকেশনের অনুমতি দেওয়া হয়নি",
    locationCouldNotGet: "আপনার লোকেশন পাওয়া যায়নি",
    heading: "আপনার জন্য ভাড়ার জায়গা খুঁজি",
    searchPlaceholder: "এলাকা বা প্রপার্টির নাম দিয়ে খুঁজুন",
    filtersBtn: "⚙ ফিল্টার",
    listView: "☰ লিস্ট ভিউ",
    mapView: "🗺️ ম্যাপ ভিউ",
    fromPrice: "{price} থেকে শুরু",
    housesCount: "{count}টি বাড়ি",
    noVacancies: "এখন কোনো খালি জায়গা নেই — একটু পরে আবার দেখুন।",
    noMatch: "আপনার সার্চ বা ফিল্টারের সাথে মিলছে এমন কোনো লিস্টিং নেই।",
    noPinnedLocation: "এই লিস্টিংগুলোর কোনোটিতেই এখনো লোকেশন পিন করা নেই।",
    distanceAway: "{value} দূরে",
    filtersTitle: "ফিল্টার",
    propertyTypeLabel: "প্রপার্টির ধরন",
    sortByLabel: "যেভাবে সাজাবেন",
    yourLocationLabel: "আপনার লোকেশন",
    locating: "লোকেশন খোঁজা হচ্ছে…",
    locationOn: "📍 লোকেশন অন আছে",
    useMyLocation: "📍 আমার লোকেশন ব্যবহার করুন",
    nearLabel: "📍 {location}-এর কাছে",
    clearAll: "সব মুছুন",
    showResults: "ফলাফল দেখান",
    backToListings: "‹ লিস্টিং-এ ফিরে যান",
    housesHeading: "বাড়ি",
    occupiedBadge: "ভর্তি",
    vacantBadge: "খালি",
    typeLabel: "ধরন",
    rentLabel: "ভাড়া",
    perMonthSuffix: "/মাস",
    depositLabel: "ডিপোজিট",
    escalationLabel: "ভাড়া বৃদ্ধি",
    yearsSuffix: "বছর",
    occupancyLabel: "অকুপেন্সি",
    mealPlanLabel: "খাবার অন্তর্ভুক্ত",
    preferredTenantsLabel: "পছন্দের ভাড়াটে",
    roomAc: "এসি",
    roomAttachedBathroom: "অ্যাটাচড বাথরুম",
    bedsVacant: "{total}টির মধ্যে {vacant}টি বেড খালি",
    locationLabel: "লোকেশন",
    openInGoogleMaps: "Google Maps-এ খুলুন",
    viewOnMap: "ম্যাপে দেখুন",
    hideMap: "ম্যাপ লুকান",
    showNearby: "আশেপাশে কী আছে দেখুন",
    hideNearby: "আশেপাশের জায়গা লুকান",
    loadingNearby: "আশেপাশের জায়গা খোঁজা হচ্ছে…",
    nearbyEmpty: "আশেপাশে কোনো জায়গা পাওয়া যায়নি",
    nearbyTransit: "ট্রানজিট",
    nearbyEssentials: "নিত্যপ্রয়োজনীয় জিনিসপত্র",
    nearbyHealthcare: "স্বাস্থ্যসেবা",
    metersAway: "{distance} মিটার দূরে",
    similarPropertiesHeading: "একই ধরনের প্রপার্টি",
    topTag: "টপ",
    featuredTag: "ফিচার্ড",
    moveInHint: "মুভ-ইন করতে, আপনার রেজিস্টার করা ফোন নম্বর দিয়ে মালিককে আপনাকে ভাড়াটে হিসেবে যোগ করতে বলুন — তারপর এটা আপনার হোম ট্যাবে নিজে থেকেই দেখাবে।",
    scheduleVisit: "ভিজিট শিডিউল করুন",
    pickDateTime: "একটি তারিখ ও সময় বেছে নিন",
    visitRequestSent: "মালিককে ভিজিট রিকোয়েস্ট পাঠানো হয়েছে",
    couldNotSendVisit: "ভিজিট রিকোয়েস্ট পাঠানো যায়নি",
    requestedFor: "{date} তারিখে {time}-এর জন্য রিকোয়েস্ট পাঠানো হয়েছে — মালিককে জানানো হয়েছে, তিনি কনফার্ম করবেন।",
    dateLabel: "তারিখ",
    timeLabel: "সময়",
    noteOptionalLabel: "নোট (ঐচ্ছিক)",
    notePlaceholder: "যেমন সন্ধ্যায় পছন্দ, আগে কল করব",
    sending: "পাঠানো হচ্ছে…",
    requestVisitBtn: "ভিজিট রিকোয়েস্ট করুন",
    ownerContactLabel: "মালিক",
    verifiedOwnerBadge: "যাচাইকৃত",
    unlockingBtn: "আনলক হচ্ছে…",
    unlockNumberFreeBtn: "🔓 নম্বর আনলক করুন — বিনামূল্যে",
    unlockUpsellTitle: "বিনামূল্যের আনলক ব্যবহার হয়ে গেছে",
    unlockUpsellBody: "বেসিক প্ল্যানে 1 জন মালিকের কন্টাক্ট বিনামূল্যে আনলক হয়। সীমাহীন মালিক আনলক করতে Tenant Pro-তে আপগ্রেড করুন।",
    unlockUpsellBtn: "Tenant Pro-তে আপগ্রেড করুন",
    callNumberBtn: "{phone}-এ কল করুন",
    whatsappBtn: "💬 WhatsApp-এ চ্যাট করুন",
    whatsappMessage: "নমস্কার, ToLetBook-এ লিস্টেড আপনার প্রপার্টি \"{property}\"-এ আমি আগ্রহী। এটা কি এখনও উপলব্ধ আছে?",
    contactUnlockedToast: "কন্টাক্ট নম্বর আনলক হয়েছে",
    couldNotUnlockToast: "কন্টাক্ট আনলক করা যায়নি",
  },
  tenantPayments: {
    noActiveTenancy: "ভাড়া দেওয়ার জন্য আপনার কোনো অ্যাক্টিভ টেনেন্সি নেই।",
    title: "পেমেন্ট",
    paidStatus: "পেমেন্ট হয়েছে",
    rentDue: "ভাড়া বাকি আছে",
    reminderBanner: "🔔 আপনার মালিক এই পেমেন্ট নিয়ে একটি রিমাইন্ডার পাঠিয়েছেন",
    payingBtn: "পেমেন্ট হচ্ছে…",
    payViaUpi: "UPI-এর মাধ্যমে {amount} দিন",
    payNow: "{amount} দিন",
    paymentFailedToast: "পেমেন্ট সম্পন্ন হয়নি — আবার চেষ্টা করুন",
    paymentRecordedToast: "পেমেন্ট রেকর্ড হয়েছে",
    viewReceiptBtn: "রসিদ দেখুন",
    history: "হিস্টরি",
    payViaUpiDirectlyBtn: "সরাসরি UPI-তে পেমেন্ট করুন",
    ownerUpiIdLabel: "মালিকের UPI ID",
    copyUpiBtn: "কপি করুন",
    upiIdCopiedToast: "UPI ID কপি হয়েছে",
    openUpiAppBtn: "UPI অ্যাপ খুলুন",
    markPaidUpiBtn: "আমি UPI-তে পেমেন্ট করেছি",
    markPaidUpiConfirm: "আপনি কি এই ভাড়া মালিকের UPI ID-তে পাঠিয়েছেন? এতে এটি পরিশোধিত হিসেবে চিহ্নিত হবে।",
  },
  tenantRequests: {
    title: "মেইনটেন্যান্স রিকোয়েস্ট",
    cancelLink: "বাতিল করুন ›",
    newLink: "+ নতুন ›",
    whatsWrong: "সমস্যা কী?",
    issuePlaceholder: "যেমন কল থেকে পানি পড়ছে",
    detailsOptional: "বিস্তারিত (ঐচ্ছিক)",
    submittingBtn: "সাবমিট হচ্ছে…",
    submitRequestBtn: "রিকোয়েস্ট সাবমিট করুন",
    giveTitleError: "রিকোয়েস্টের একটা টাইটেল দিন",
    requestRaisedToast: "রিকোয়েস্ট পাঠানো হয়েছে",
    noRequestsYet: "এখনো কোনো রিকোয়েস্ট পাঠানো হয়নি।",
    noDetailsProvided: "কোনো বিস্তারিত দেওয়া হয়নি",
    myVisitsHeading: "আমার ভিজিট রিকোয়েস্ট",
    emptyNoVisits: "আপনি এখনো কোনো প্রপার্টি ভিজিট রিকোয়েস্ট করেননি।",
    visitLine: "{date} তারিখে {time}-এ",
    cancelVisitButton: "বাতিল করুন",
    visitCancelledToast: "ভিজিট রিকোয়েস্ট বাতিল করা হয়েছে",
    visitStatusPending: "বিচারাধীন",
    visitStatusConfirmed: "নিশ্চিত করা হয়েছে",
    visitStatusDeclined: "প্রত্যাখ্যাত",
    visitStatusCancelled: "বাতিল করা হয়েছে",
    vacateNoticeHeading: "খালি করার নোটিস",
    giveNoticeLink: "+ নোটিস দিন ›",
    vacateOnLabel: "{date} তারিখে খালি হবে",
    noticeGivenOnLabel: "{date} তারিখে নোটিস দেওয়া হয়েছে",
    vacateStatusPending: "বিচারাধীন",
    vacateStatusAcknowledged: "গৃহীত",
    vacateStatusCancelled: "বাতিল করা হয়েছে",
    shareWhatsappBtn: "💬 WhatsApp-এ শেয়ার করুন",
    cancelNoticeBtn: "নোটিস বাতিল করুন",
    noticeDateLabel: "নোটিসের তারিখ",
    vacateDatePreview: "আপনার {days}-দিনের নোটিস পিরিয়ড অনুযায়ী, আপনি {date} তারিখে খালি করবেন",
    submitVacateNoticeBtn: "খালি করার নোটিস সাবমিট করুন",
    vacateNoticeSentToast: "খালি করার নোটিস মালিকের কাছে পাঠানো হয়েছে",
    vacateNoticeCancelledToast: "খালি করার নোটিস বাতিল করা হয়েছে",
    emptyNoVacateNotices: "আপনি এখনো কোনো খালি করার নোটিস দেননি।",
    vacateWhatsappMessage: "নমস্কার {owner}, এটি আনুষ্ঠানিক নোটিস যে \"{property}\" {vacateDate} তারিখে খালি করা হবে। নোটিস {noticeDate} তারিখে দেওয়া হয়েছে।",
  },
  tenantOnboarding: {
    title: "আপনার মুভ-ইন সম্পূর্ণ করুন",
    nameLabel: "আপনার নাম (আধার অনুযায়ী)",
    nameHint: "এই সঠিক নামটি আপনার রেন্টাল এগ্রিমেন্টে ব্যবহার করা হবে।",
    rentLabel: "মাসিক ভাড়া",
    dueDayLabel: "ভাড়া দেওয়ার দিন",
    dueDayValue: "প্রতি মাসের {day} তারিখ",
    depositLabel: "সিকিউরিটি ডিপোজিট",
    depositPaidBadge: "পেমেন্ট হয়েছে",
    depositPendingBadge: "বাকি",
    depositConfirmingBadge: "নিশ্চিত করা হচ্ছে…",
    payNowBtn: "এখনই দিন",
    payingBtn: "পেমেন্ট খুলছে…",
    depositPaymentDesc: "সিকিউরিটি ডিপোজিট",
    depositPaidToast: "ডিপোজিট পেমেন্ট পাওয়া গেছে",
    depositFailedToast: "পেমেন্ট সম্পন্ন হয়নি — আবার চেষ্টা করুন",
    depositPaidCashBadge: "নগদে পরিশোধ করা হয়েছে",
    paidInCashLink: "আমি নগদে পরিশোধ করেছি",
    cashProofHint: "রসিদ বা পেমেন্টের প্রমাণের ছবি যোগ করুন (ঐচ্ছিক)।",
    cashProofUploadLabel: "প্রমাণ যোগ করুন",
    confirmCashBtn: "নগদ পেমেন্ট নিশ্চিত করুন",
    errDepositRequired: "এগিয়ে যাওয়ার আগে সিকিউরিটি ডিপোজিট পরিশোধ করুন (অনলাইন বা নগদ)",
    amenitiesLabel: "মালিকের দেওয়া সুযোগ-সুবিধা",
    identityVerificationLabel: "পরিচয় যাচাই",
    yourIdentityLabel: "আপনি",
    identityVerificationHint: "আপনার সরকারি-যাচাইকৃত নাম রেন্টাল এগ্রিমেন্টে দেখানোর জন্য DigiLocker দিয়ে আপনার পরিচয় যাচাই করুন।",
    confirmLabel: "আমি উপরে দেওয়া আমার মুভ-ইন তথ্য দেখেছি এবং নিশ্চিত করছি যে তা সঠিক।",
    submitBtn: "সেটআপ সম্পূর্ণ করুন",
    errNameRequired: "আপনার নাম লিখুন",
    errMustConfirm: "দয়া করে নিশ্চিত করুন যে আপনি তথ্য দেখেছেন",
    completedToast: "মুভ-ইন তথ্য নিশ্চিত করা হয়েছে",
  },
  moveInDetails: {
    title: "মুভ-ইন তথ্য",
  },
  locationCapture: {
    pinLocationLabel: "এই প্রপার্টির লোকেশন পিন করুন",
    panMapHint: "📌 সঠিক জায়গায় পিন রাখতে ম্যাপ সরান",
    expandMapAria: "ম্যাপ বড় করুন",
    clear: "মুছুন",
    searchPlaceholder: "একটি ঠিকানা খুঁজুন",
    loadingSearch: "সার্চ লোড হচ্ছে…",
    or: "অথবা",
    locating: "লোকেশন খোঁজা হচ্ছে…",
    useCurrentLocation: "📍 বর্তমান লোকেশন ব্যবহার করুন",
    pickSuggestion: "ড্রপডাউন থেকে একটা সাজেশন বেছে নিন",
    locationNotSupported: "এই ব্রাউজারে লোকেশন সাপোর্ট করে না",
    locationPermissionDenied: "লোকেশনের অনুমতি দেওয়া হয়নি",
    locationCouldNotGet: "আপনার লোকেশন পাওয়া যায়নি",
    hint: "একটা ঠিকানা খুঁজুন বা নিচের এলাকা অটো-ফিল করতে GPS-এ ট্যাপ করুন — দরজার নম্বর ও বিল্ডিংয়ের নাম আপনাকে নিজেই লিখতে হবে।",
  },
  googleMap: {
    yourLocation: "আপনার লোকেশন",
    couldNotLoad: "Google Maps লোড করা যায়নি — API কী চেক করুন",
    viewDetails: "বিস্তারিত দেখুন ›",
  },
  rentReceipt: {
    back: "‹ ফিরে যান",
    paymentRecordedBanner: "✓ পেমেন্ট রেকর্ড হয়েছে — এই যে আপনার রসিদ।",
    title: "ভাড়ার রসিদ",
    amountPaid: "পরিশোধিত পরিমাণ",
    receiptNoLabel: "রসিদ নম্বর",
    paidByLabel: "পরিশোধ করেছেন",
    propertyLabel: "প্রপার্টি",
    receivedByLabel: "গ্রহণ করেছেন",
    forMonthLabel: "যে মাসের জন্য",
    paymentModeLabel: "পেমেন্ট মোড",
    paidOnLabel: "পরিশোধের তারিখ",
    downloadBtn: "ডাউনলোড করুন",
    shareBtn: "শেয়ার করুন",
    htmlTitle: "ভাড়ার রসিদ - {month}",
    htmlStamp: "✓ পরিশোধিত",
    htmlAmountPaidLabel: "পরিশোধিত পরিমাণ",
    htmlFooter: "এটি ToLetBook থেকে সিস্টেম-জেনারেটেড একটি রসিদ। এখানে দেখানো ভাড়া অ্যাপের মধ্যে রেকর্ড করা হয়েছে, কোনো আসল পেমেন্ট গেটওয়ের মাধ্যমে প্রসেস করা হয়নি।",
    shareTitle: "ভাড়ার রসিদ - {month}",
    shareText: "রসিদ {receiptNo}, পরিমাণ {amount}",
  },
  rentalAgreement: {
    back: "‹ ফিরে যান",
    title: "রেন্টাল এগ্রিমেন্ট",
    ownerLabel: "মালিক",
    tenantLabel: "ভাড়াটে",
    propertyLabel: "প্রপার্টি",
    typeLabel: "ধরন",
    monthlyRentLabel: "মাসিক ভাড়া",
    securityDepositLabel: "সিকিউরিটি ডিপোজিট",
    moveInDateLabel: "মুভ-ইন তারিখ",
    disclaimer: "এটি রেকর্ডে থাকা টেনেন্সির তথ্য থেকে স্বয়ংক্রিয়ভাবে তৈরি একটি সারসংক্ষেপ, আইনগতভাবে বাধ্যতামূলক কোনো ডকুমেন্ট নয়। সাধারণ ডেমো শর্তাবলী: প্রতি মাসের 5 তারিখের মধ্যে ভাড়া দিতে হবে, টেনেন্সি শেষ করতে 30 দিনের নোটিশ, স্বাভাবিক ক্ষয়ক্ষতির বাইরে কোনো ক্ষতির টাকা কেটে নিয়ে ডিপোজিট ফেরতযোগ্য।",
    downloadAgreementBtn: "এগ্রিমেন্ট ডাউনলোড করুন",
    stampStatusLabel: "E-Stamp স্ট্যাটাস",
    stampStatusNotStarted: "শুরু হয়নি",
    stampStatusProcessing: "প্রসেস হচ্ছে",
    stampStatusVerified: "ভেরিফাইড",
    stampHint: "এই এগ্রিমেন্টটি সরকার থেকে আইনগতভাবে E-Stamp করান। এর জন্য {amount} আসল সরকারি ফি প্রযোজ্য।",
    stampFeeAlreadyPaidHint: "আপনার E-Stamp ফি দেওয়া হয়ে গেছে — শুধু অর্ডারটি এখনও দেওয়া যায়নি। কোনো অতিরিক্ত চার্জ ছাড়াই নিচে আবার চেষ্টা করুন।",
    sendForStampBtn: "{amount} দিয়ে E-Stamp এর জন্য পাঠান",
    retrySendForStampBtn: "E-Stamp এর জন্য আবার পাঠান",
    sendingStampBtn: "পাঠানো হচ্ছে…",
    confirmingPaymentBtn: "পেমেন্ট নিশ্চিত করা হচ্ছে…",
    stampFeePaymentDesc: "সরকারি E-Stamp ফি",
    stampFeeFailedToast: "পেমেন্ট ব্যর্থ হয়েছে — আবার চেষ্টা করুন",
    stampSentToast: "সরকারি E-Stamping এর জন্য পাঠানো হয়েছে",
    refreshStatusBtn: "স্ট্যাটাস রিফ্রেশ করুন",
    viewStampedBtn: "স্ট্যাম্পড এগ্রিমেন্ট দেখুন",
    identityVerificationLabel: "পরিচয় যাচাইকরণ",
    digilockerVerifiedBadge: "যাচাইকৃত",
    digilockerNotVerifiedBadge: "যাচাই করা হয়নি",
    verifyDigilockerBtn: "DigiLocker দিয়ে যাচাই করুন",
    verifyingDigilockerBtn: "DigiLocker খুলছে…",
    digilockerVerifiedToast: "{name} হিসেবে যাচাই করা হয়েছে",
    digilockerDeniedToast: "DigiLocker যাচাইকরণ বাতিল করা হয়েছে",
    digilockerExpiredToast: "সেই DigiLocker লিঙ্কের মেয়াদ শেষ হয়ে গেছে — আবার চেষ্টা করুন",
    comingSoonTitle: "সরকারি ই-স্ট্যাম্পিং শীঘ্রই আসছে",
    comingSoonBody: "আমরা স্ট্যাম্প ডিউটি পেমেন্ট সেট আপ করছি যাতে আপনি অ্যাপ থেকেই সম্পূর্ণ সরকার-যাচাইকৃত, ই-স্ট্যাম্পড ভাড়ার চুক্তি তৈরি করতে পারেন।",
    interestBtn: "আমি আগ্রহী — জানান",
    interestRegisteredBtn: "আপনি তালিকায় আছেন ✓",
    interestToast: "ধন্যবাদ! ই-স্ট্যাম্পিং লাইভ হলে আমরা আপনাকে জানাব।",
    uploadDocHeading: "ইতিমধ্যে ভাড়ার চুক্তি আছে?",
    uploadDocHint: "আপনি যদি ToLetBook এর বাইরে ইতিমধ্যে একটি তৈরি করে থাকেন, তাহলে এই ভাড়াটের সাথে সেভ হওয়ার জন্য এখানে আপলোড করুন।",
    uploadDocBtn: "ভাড়ার চুক্তি আপলোড করুন",
    viewUploadedDocBtn: "আপলোড করা চুক্তি দেখুন",
    removeUploadedDocBtn: "সরান",
    uploadedOnLabel: "{date} তারিখে আপলোড হয়েছে",
    noUploadedDocTenantHint: "আপনার বাড়িওয়ালা এখনও ভাড়ার চুক্তি আপলোড করেননি।",
    uploadDocSuccessToast: "ভাড়ার চুক্তি আপলোড হয়েছে",
    uploadDocFailedToast: "আপলোড করা যায়নি — 8MB এর কম PDF বা ছবি চেষ্টা করুন",
    removeDocConfirm: "আপলোড করা ভাড়ার চুক্তি সরাতে চান?",
    removeDocSuccessToast: "ভাড়ার চুক্তি সরানো হয়েছে",
    htmlTitle: "রেন্টাল এগ্রিমেন্ট - {property}",
    htmlDocTitle: "রেন্টাল এগ্রিমেন্ট সারসংক্ষেপ",
    htmlAgreementNo: "এগ্রিমেন্ট নম্বর {no}",
    htmlOwnerLessor: "মালিক / লেসর",
    htmlTenantLessee: "ভাড়াটে / লেসি",
    htmlPropertyHeading: "প্রপার্টি",
    htmlAddressLabel: "ঠিকানা",
    htmlTypeLabel: "ধরন",
    htmlTermsHeading: "শর্তাবলী",
    htmlMonthlyRentLabel: "মাসিক ভাড়া",
    htmlSecurityDepositLabel: "সিকিউরিটি ডিপোজিট",
    htmlMoveInDateLabel: "মুভ-ইন তারিখ",
    htmlConditionsHeading: "শর্তসমূহ",
    htmlCond1: "প্রতি মাসের 5 তারিখের মধ্যে বা তার আগে, সম্মত পদ্ধতিতে মালিককে ভাড়া দিতে হবে।",
    htmlCond2: "মুভ-আউটের সময় সিকিউরিটি ডিপোজিট ফেরত দেওয়া হবে, স্বাভাবিক ক্ষয়ক্ষতির বাইরে কোনো ক্ষতির টাকা কেটে নিয়ে।",
    htmlCond3: "টেনেন্সি শেষ করার আগে দুই পক্ষের যেকোনো একজনকে অন্তত 30 দিনের লিখিত নোটিশ দিতে হবে।",
    htmlCond4: "মালিকের সাথে অন্য কোনো সমঝোতা না থাকলে, ইউটিলিটি বিলের দায়িত্ব ভাড়াটের।",
    htmlCond5: "ফিক্সচার ও ফিটিংসের মেইনটেন্যান্সের দায়িত্ব মালিকের, যদি না ভাড়াটের অবহেলার কারণে ক্ষতি হয়।",
    htmlFooter: "এই সারসংক্ষেপ ToLetBook দ্বারা রেকর্ডে থাকা টেনেন্সির তথ্য থেকে স্বয়ংক্রিয়ভাবে তৈরি, এবং এটি আইনগতভাবে বাধ্যতামূলক কোনো ডকুমেন্ট নয়। একটি আনুষ্ঠানিক রেন্টাল এগ্রিমেন্ট তৈরি করতে একজন আইন বিশেষজ্ঞের পরামর্শ নিন।",
  },
  photoLightbox: {
    closeAria: "বন্ধ করুন",
    previousPhotoAria: "আগের ছবি",
    nextPhotoAria: "পরের ছবি",
    countLabel: "{current} / {total}",
  },
  tenantPlan: {
    title: "প্ল্যান",
    currentPlanLabel: "বর্তমান প্ল্যান",
    basicName: "বেসিক",
    proName: "ভাড়াটে প্রো",
    proSub: "সক্রিয়ভাবে বাড়ি খুঁজছেন এমন ভাড়াটেদের জন্য",
    priceValidity: "1 মাসের জন্য বৈধ",
    featUnlock: "30 দিনের জন্য সীমাহীন মালিকের যোগাযোগ নম্বর আনলক করুন",
    featNearby: "প্রতিটি লিস্টিংয়ে সম্পূর্ণ ম্যাপ এবং কাছাকাছি-স্থানের অ্যাক্সেস",
    featWhatsapp: "মালিকের সাথে সরাসরি WhatsApp-এ কথা বলুন, প্রতি-লিস্টিং ফি নেই",
    featFallback: "সাবস্ক্রাইব না করলেও 1 জন মালিকের কন্টাক্ট বিনামূল্যে আনলক হয় — এরপর আপগ্রেড করতে হবে",
    currentPlanBtn: "বর্তমান প্ল্যান",
    subscribeBtn: "₹99-এ সাবস্ক্রাইব করুন",
    activeUntil: "{date} পর্যন্ত সক্রিয়",
    noChargeNote: "এখনও কোনো পেমেন্ট প্রয়োজন নেই — বিলিং সেটআপ না হওয়া পর্যন্ত সাবস্ক্রাইব করা বিনামূল্যে।",
    subscribedToast: "ভাড়াটে প্রো সক্রিয় করা হয়েছে",
    switchFailedToast: "আপনার প্ল্যান আপডেট করা যায়নি",
    nearbyUpsellTitle: "ম্যাপ এবং কাছাকাছি স্থানগুলি আনলক করুন",
    nearbyUpsellBody: "প্রতিটি লিস্টিংয়ের কাছে ট্রানজিট, প্রয়োজনীয় জিনিসপত্র এবং স্বাস্থ্যসেবা দেখতে ভাড়াটে প্রো-তে সাবস্ক্রাইব করুন।",
    nearbyUpsellBtn: "ভাড়াটে প্রো দেখুন",
    cancelPlanBtn: "প্ল্যান বাতিল করুন",
    securePaymentNote: "Razorpay-এর মাধ্যমে পেমেন্ট নিরাপদে প্রসেস করা হয়।",
    cancelledToast: "ভাড়াটে প্রো বাতিল করা হয়েছে",
  },
};
